import { useHistory } from 'react-router-dom'
import LayoutPartner from '../../components/BasicComponent/LayoutPartner'
import './index.scss'

export default function TrafficFineTermsOfServicePayment() {
  const history = useHistory()

  return (
    <LayoutPartner onGoBack={() => history.goBack()}>
      <div className="TrafficFineTermsOfServicePayment">
        <div className="TrafficFineTermsOfServicePayment_mainTitle">Điều khoản thanh toán và Chính sách bảo vệ dữ liệu cá nhân</div>
        {/* Section 1 */}
        <div className="TrafficFineTermsOfServicePayment_sectionTitle">1. Chính sách thanh toán</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Chính sách thanh toán linh hoạt của TAMOVE giúp quý khách hàng dễ dàng lựa chọn phương thức phù hợp với nhu cầu mua sắm của mình. Chúng tôi cung cấp nhiều phương thức thanh toán khác nhau, đáp ứng cả mua sắm trực tiếp và trực tuyến.
        </div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Quý khách có thể đặt dịch vụ thông qua Website:{' '}
          <a href="https://miniapp-thongbaophatnguoi.tamove.vn/" target="_blank" rel="noopener noreferrer" className="TrafficFineTermsOfServicePayment_link">
            https://miniapp-thongbaophatnguoi.tamove.vn/
          </a>{' '}
          hoặc số điện thoại: 0962.705.608
        </div>
        <div className="TrafficFineTermsOfServicePayment_subTitle">Chuyển khoản qua ngân hàng:</div>
        <ul className="TrafficFineTermsOfServicePayment_list">
          <li>Số TK: 11229885</li>
          <li>Chủ tài khoản: CONG TY CP CHUYEN DOI DLS TRUONG AN</li>
          <li>Ngân hàng: Techcombank</li>
        </ul>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          *Chú ý: Để đặt mua dịch vụ, vui lòng thanh toán chuyển khoản trước. Nhân viên của TAMOVE sẽ liên hệ trực tiếp với bạn để xác nhận thanh toán. Nếu có bất kỳ thắc mắc hoặc cần hỗ trợ về dịch vụ, quý khách vui lòng liên hệ với đội ngũ chăm sóc khách hàng của chúng tôi qua số hotline: 0962.705.608 hoặc email: TAMOVE để được giải đáp nhanh chóng.
        </div>

        {/* Section: Nghĩa Vụ Của Người Bán */}
        <div className="TrafficFineTermsOfServicePayment_subTitle">Nghĩa Vụ Của Người Bán</div>
        <div className="TrafficFineTermsOfServicePayment_subTitle">Cung Cấp Thông Tin Chính Xác:</div>
        <ul className="TrafficFineTermsOfServicePayment_list">
          <li>Người bán có trách nhiệm cung cấp thông tin chính xác và đầy đủ về sản phẩm, dịch vụ, giá cả, điều kiện giao dịch, phương thức thanh toán và giao hàng.</li>
          <li>Đảm bảo các thông tin này luôn được cập nhật để tránh gây hiểu lầm cho khách hàng.</li>
        </ul>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Đảm Bảo Chất Lượng Sản Phẩm:</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Cam kết cung cấp sản phẩm, dịch vụ đúng như mô tả, đảm bảo chất lượng và nguồn gốc xuất xứ. Giải quyết các khiếu nại liên quan đến chất lượng sản phẩm một cách nhanh chóng và thỏa đáng. TAMOVE sẽ chịu mọi trách nhiệm trước pháp luật nếu sản phẩm, dịch vụ gây ảnh hưởng đến sức khỏe và cuộc sống người tiêu dùng.
        </div>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Giao Hàng Đúng Hẹn:</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Tuân thủ thời gian giao hàng đã cam kết với khách hàng. Thông báo kịp thời cho khách hàng nếu có bất kỳ thay đổi nào về thời gian giao hàng.
        </div>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Bảo Vệ Thông Tin Khách Hàng:</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Đảm bảo an toàn và bảo mật thông tin cá nhân của khách hàng. Không tiết lộ thông tin khách hàng cho bên thứ ba khi chưa có sự đồng ý của khách hàng.
        </div>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Chính Sách Đổi Trả và Bảo Hành:</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Cung cấp chính sách đổi trả và bảo hành rõ ràng, minh bạch. Hỗ trợ khách hàng trong quá trình đổi trả và bảo hành sản phẩm.
        </div>

        {/* Section: Nghĩa Vụ Của Khách Hàng */}
        <div className="TrafficFineTermsOfServicePayment_subTitle">Nghĩa Vụ Của Khách Hàng</div>
        <div className="TrafficFineTermsOfServicePayment_subTitle">Cung Cấp Thông Tin Chính Xác:</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Khách hàng có trách nhiệm cung cấp thông tin cá nhân và địa chỉ giao hàng chính xác. Cập nhật thông tin khi có sự thay đổi để đảm bảo quá trình giao dịch diễn ra thuận lợi.
        </div>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Kiểm Tra Sản Phẩm Khi Nhận Hàng:</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Kiểm tra kỹ sản phẩm khi nhận hàng để phát hiện các lỗi hoặc hư hỏng. Thông báo ngay cho người bán nếu phát hiện vấn đề để được hỗ trợ kịp thời.
        </div>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Thanh Toán Đúng Hạn:</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Thanh toán đầy đủ và đúng hạn theo các phương thức đã thỏa thuận. Tuân thủ các điều khoản và điều kiện thanh toán đã được thống nhất.
        </div>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Tuân Thủ Chính Sách Đổi Trả và Bảo Hành:</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Đọc và hiểu rõ các chính sách đổi trả và bảo hành của người bán. Tuân thủ các quy định trong quá trình đổi trả và bảo hành sản phẩm.
        </div>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Tôn Trọng Thỏa Thuận:</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Tôn trọng các thỏa thuận và cam kết đã được đưa ra trong quá trình giao dịch. Không có các hành vi lừa đảo, gian lận hoặc vi phạm pháp luật.
        </div>

        {/* Section 2 */}
        <div className="TrafficFineTermsOfServicePayment_sectionTitle">2. Chính sách bảo vệ, chia sẻ DLCN</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          TAMOVE xử lý dữ liệu dựa trên sự đồng ý rõ ràng, tự nguyện của khách hàng; để giao kết, thực hiện hợp đồng hoặc cung cấp dịch vụ theo yêu cầu; để tuân thủ nghĩa vụ pháp lý; hoặc trong trường hợp khác mà pháp luật cho phép xử lý không cần sự đồng ý.
        </div>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Dữ liệu được xử lý</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          TAMOVE có thể xử lý các dữ liệu do khách hàng cung cấp hoặc phát sinh trong quá trình sử dụng dịch vụ, gồm: họ tên, số điện thoại, email; thông tin phương tiện/biển số xe; thông tin đơn hàng, thanh toán, lịch sử sử dụng dịch vụ; nội dung trao đổi, yêu cầu hỗ trợ và thông tin kỹ thuật cần thiết để vận hành nền tảng.
        </div>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Mục đích sử dụng</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Dữ liệu cá nhân được sử dụng để xác minh khách hàng; tiếp nhận và thực hiện đơn hàng; cung cấp dịch vụ thông báo phạt nguội và các tiện ích khác do TAMOVE cung cấp; xử lý thanh toán, xuất hóa đơn, chăm sóc khách hàng, giải quyết khiếu nại; bảo đảm an toàn hệ thống, phòng chống gian lận và thực hiện nghĩa vụ theo quy định pháp luật.
        </div>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Phạm vi chia sẻ</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          TAMOVE chỉ chia sẻ dữ liệu trong phạm vi cần thiết với ngân hàng hoặc đơn vị trung gian thanh toán; đối tác cung cấp dữ liệu, gửi thông báo, lưu trữ và vận hành kỹ thuật; hoặc cơ quan có thẩm quyền theo yêu cầu hợp pháp. Bên nhận phải sử dụng đúng mục đích và bảo mật. TAMOVE không bán, cho thuê hay trao đổi dữ liệu cá nhân trái với sự đồng ý của khách hàng.
        </div>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Bảo mật và thời gian lưu trữ</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          TAMOVE áp dụng biện pháp quản lý và kỹ thuật phù hợp để hạn chế truy cập, sử dụng, tiết lộ, thay đổi hoặc mất dữ liệu trái phép. Dữ liệu được lưu trong thời gian cần thiết để cung cấp dịch vụ, giải quyết nghĩa vụ liên quan hoặc theo thời hạn pháp luật quy định; sau đó được xóa, hủy hoặc ẩn danh theo quy trình phù hợp.
        </div>

        <div className="TrafficFineTermsOfServicePayment_subTitle">Quyền của khách hàng</div>
        <div className="TrafficFineTermsOfServicePayment_paragraph">
          Khách hàng có quyền yêu cầu được biết, truy cập, chỉnh sửa, hạn chế xử lý, rút lại sự đồng ý, xóa dữ liệu hoặc khiếu nại theo quy định pháp luật. Việc rút lại sự đồng ý không làm ảnh hưởng đến tính hợp pháp của hoạt động xử lý đã được thực hiện trước thời điểm rút lại; một số yêu cầu có thể làm TAMOVE không thể tiếp tục cung cấp dịch vụ tương ứng.
        </div>
      </div>
    </LayoutPartner>
  )
}
